import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const updatePledge = ({
  churchId,
  campaignId,
  pledgeId,
  pledgeData
}) => {
  return axios.patch(
    `/churches/${churchId}/campaigns/${campaignId}/pledges/${pledgeId}`,
    pledgeData
  );
};

export const useUpdatePledge = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("campaigns-paginated");

      setNotification({
        type: "success",
        message: "Pledge updated successfully!"
      });
    },
    ...config,
    mutationFn: updatePledge
  });
};
